import React from 'react';

import { GhostElement } from 'src/app/components/GhostElement/GhostElement';
import { InfiniteLoadMore } from 'src/app/components/Infinite/InfiniteLoadMore';
import { VideoItem } from 'src/app/components/Video/VideoItem';
import { VIDEO_ITEM_TYPE } from 'src/app/constants/video';
import { withStyles } from 'src/app/helpers/styles';
import { UserPlaylists } from 'src/app/models/user';
import { VideoCard } from 'src/app/models/video';
import { AddToWatchlistFunction } from 'src/app/models/watchlist';

interface MyProps {
  videos: VideoCard[];
  onWatchlistButtonClick?: AddToWatchlistFunction;
  hasMore?: boolean;
  loadMore?: VoidFunction;
  scrollLoading?: number;
  railAnalyticsVideo?: string;
  railAnalyticsProgram?: string;
  user?: UserPlaylists;
  eventLabel?: string;
}

@withStyles(require('./InfiniteVideoGridColumn.scss'))
export class InfiniteVideoGridColumn extends React.Component<MyProps> {
  render(): JSX.Element {
    const { hasMore, loadMore, scrollLoading } = this.props;
    return (
      <InfiniteLoadMore
        className="container-grid mb-16 mb@md-n42 mr@md-n30"
        hasMore={hasMore}
        loadMore={loadMore}
        scrollLoading={scrollLoading}
      >
        {this.videoItems}
        <GhostElement className="mr@md-30 infinite-video-grid-column__ghost-element" count={4} />
      </InfiniteLoadMore>
    );
  }

  private get videoItems(): JSX.Element[] {
    const { onWatchlistButtonClick, videos, railAnalyticsVideo, railAnalyticsProgram, user, eventLabel } = this.props;
    return videos.map((video) => {
      return (
        <VideoItem
          className="mb-12 mb@md-42 mr@md-30"
          key={'infinite-video-grid-column-item-' + video.id}
          onWatchlistButtonClick={onWatchlistButtonClick}
          type={VIDEO_ITEM_TYPE.COLUMN}
          video={video}
          railAnalyticsVideo={railAnalyticsVideo}
          railAnalyticsProgram={railAnalyticsProgram}
          user={user}
          eventLabel={eventLabel}
        />
      );
    });
  }
}
